import { connect } from 'react-redux';

import InstallerLinkComponent from './../Components/InstallerLinkComponent.jsx';
import { build as constants, copyToClipboard } from './../helpers';
import { toastr } from './../actions';

const copyInstallerPath = (build, onSuccess) => {
  const product = constants.PROD_BY_PRODUCT[constants.getBuildProduct(build)];

  let installerPath;
  if (product === constants.PRODUCTS.IEF) {
    installerPath = `${constants.INSTALLER_ROOT}\\ief\\fury` +
                    `\\${constants.getBuildVersion(build)}\\standard\\installer` +
                    '\\IEFv68setup.exe';
  } else {
    const fileName = `AXIOMv${constants.getBuildMajor(build)}` +
                     `${constants.getBuildMinor(build)}` +
                     `${constants.getBuildRevision(build)}.` +
                     `${constants.getBuildBuildNumber(build)}setup.exe`;
    installerPath = `${constants.INSTALLER_ROOT}\\axiom\\fury` +
                    `\\${constants.getBuildVersion(build)}\\standard\\installer` +
                    `\\${fileName}`;
  }

  copyToClipboard(installerPath);

  if (onSuccess) {
    onSuccess();
  }
};

const mapStateToProps = () => {
  return {};
};

export const mapDispatchToProps = () => {
  return {
    onClick: (build) => copyInstallerPath(
      build,
      () => toastr.info('Copied Installer Path')
    )
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InstallerLinkComponent);


// WEBPACK FOOTER //
// src/Containers/InstallerLinkContainer.jsx